import { CommonModule } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { MenuItem } from "primeng/api";
import { BadgeModule } from "primeng/badge";
import { ButtonModule } from "primeng/button";
import { MenuModule } from "primeng/menu";
import { PanelMenuModule } from "primeng/panelmenu";

import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { PopoverModule } from "primeng/popover";
import { RippleModule } from "primeng/ripple";
import { finalize, Subscription } from "rxjs";
import { User } from "../../interfaces/user/user.model";
import { AuthService } from "../../services/auth.service";
import { HeaderService } from "../../services/header.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { ViewProfileDataComponent } from "../view-profile-data/view-profile-data.component";
import { HasPermissionDirective } from "../../directives/has-permission.directive";

@Component({
    selector: "app-header",
    imports: [
        BadgeModule,
        RouterModule,
        CommonModule,
        PanelMenuModule,
        RippleModule,
        ButtonModule,
        MenuModule,
        PopoverModule,
        HasPermissionDirective,
    ],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.css",
})
export class HeaderComponent implements OnInit, OnDestroy {
    logoutDisaabled: boolean = false;
    items: MenuItem[] | undefined;
    @Input() title: string = "";
    @Input() subtitle: string = "";
    isMenuOpen: boolean = false;
    logoutMenu: MenuItem[] | undefined;
    @Input() activeUser: User | undefined;
    menuList: MenuItem[] = [];
    roleName: string | undefined = "";
    menuSubscription: Subscription = new Subscription();

    ref: DynamicDialogRef | null = null;

    constructor(
        private authService: AuthService,
        private localStorageService: LocalStorageService,
        private router: Router,
        private headerService: HeaderService,
        private dialogService: DialogService,
    ) {}

    ngOnInit() {
        // this.logoutMenu = [
        //   {
        //     label: 'Odjavi se',
        //     command: () => {
        //       this.onLogout();
        //     },
        //   },
        // ];

        this.roleName = this.activeUser?.data.roles[0].name;
        this.menuSubscription = this.headerService.getMenuList().subscribe((menuList) => {
            this.menuList = menuList;
        });
    }

    onLogout() {
        this.logoutDisaabled = true;
        this.authService
            .logout()
            .pipe(
                finalize(() => {
                    this.logoutDisaabled = false;
                }),
            )
            .subscribe({
                next: (res: HttpResponse<any>) => {
                    this.authService.setActiveUser(null);
                    this.localStorageService.removeToken();
                    this.router.navigate([""]);
                },
                error: (error) => {},
            });
    }
    openMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    onViewProfile() {
        this.ref = this.dialogService.open(ViewProfileDataComponent, {
            maskStyleClass: "custom-backdrop",
            closable: true,
            modal: true,
            styleClass: "xl:w-2/5 lg:w-2/3 sm:w-5/6",
            position: "top",
            data: this.activeUser,
            header: "Pregled profila",
        });
    }

    ngOnDestroy(): void {
        this.menuSubscription.unsubscribe();
    }
}
